var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      on: {
        command: _vm.handleCommand,
        "visible-change": _vm.handleVisibleChange,
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function () {
            return [
              _c(
                "el-dropdown-menu",
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { command: "personalCenter" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.translateTitle("マイアカウント")) + " "
                      ),
                      _c("svg-icon", {
                        staticClass: "external",
                        attrs: { "icon-class": "external_link_line2" },
                      }),
                    ],
                    1
                  ),
                  _c("el-dropdown-item", { attrs: { command: "logout" } }, [
                    _vm._v(
                      " " + _vm._s(_vm.translateTitle("ログアウト")) + " "
                    ),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("span", { staticClass: "avatar-dropdown" }, [
        _c("div", { staticClass: "user-name" }, [
          _c("img", {
            staticClass: "head_icon",
            attrs: { src: require("@/assets/images/head_icon.png") },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }